import React from 'react';
import styles from './Badge.module.css';

const clsx = (...args) => args.filter(Boolean).join(' ');

function Badge({
  children,
  variant = 'default',
  tone = 'light',
  pill = false,
  dot = false,
  className,
  ...rest
}) {
  const cls = clsx(
    styles.badge,
    styles[variant],
    tone === 'dark' && styles.onDark,
    pill && styles.pill,
    className
  );
  return (
    <span className={cls} {...rest}>
      {dot && <span className={styles.dot} />}
      {children}
    </span>
  );
}

export default Badge;
